import React from 'react';
import { Create } from 'react-admin';
import PositionRateSettingsForm from '../shared/position-rate-settings-form/PositionRateSettingsForm';
import { getTransform } from '../rateSettingsTransform';

const AgencyLocationPositionRateSettingCreate = () => (
  <Create transform={getTransform(['agency_id', 'location_id'], 'settings')}>
    <PositionRateSettingsForm settingsField="settings" />
  </Create>
);

export default AgencyLocationPositionRateSettingCreate;
